export const CrossIcon = ({ circle = true, strokeWidth, width, height, ...props }) => (
  <svg
    width={width || 18}
    height={height || 18}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    {circle ? (
      <path
        d='M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z'
        fill='white'
        stroke='black'
        strokeWidth={strokeWidth || 0.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : null}
    <path
      strokeWidth={strokeWidth || 1}
      d='M11.4094 6.60938L6.60938 11.4094'
      stroke='black'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path

      strokeWidth={strokeWidth || 1}
      d='M6.60938 6.60938L11.4094 11.4094'
      stroke='black'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
